import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";

export const updateSailor = async (sailorId, values) => {
  await setDoc(
    doc(db, "sailors", sailorId),
    {
      ...values,
      updatedAt: new Date(),
    },
    { merge: true }
  );
};

export const addAddress = async (fields, sailorId) =>
  await addDoc(collection(db, "sailorAddresses"), {
    ...fields,
    sailor: doc(db, "sailors", sailorId),
    createdAt: serverTimestamp(),
  });

export const removeAddress = async ({ id }) => {
  return await deleteDoc(doc(db, "sailorAddresses", id));
};

export const updateSailorRiskProfile = async ({ sailorId, values }) =>
  await setDoc(
    doc(db, "sailorRiskProfiles", sailorId),
    {
      ...values,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );

export async function addNote({ title, body, user, sailor, noteCategory }) {
  const values = {
    title,
    body,
    postedBy: doc(db, "admins", user.uid),
    createdAt: serverTimestamp(),
  };

  await addDoc(
    collection(db, "sailorRiskProfiles", sailor.id, noteCategory),
    values
  );
}
